// utils/auth.js
import Cookies from 'js-cookie'

// 设置token到cookie
export const setTokens = (accessToken, refreshToken) => {
  Cookies.set('access_token', accessToken, { expires: 1 / 24 }) // 1小时
  Cookies.set('refresh_token', refreshToken, { expires: 7 }) // 7天
}

// 移除token
export const removeTokens = () => {
  Cookies.remove('access_token')
  Cookies.remove('refresh_token')
}

// 获取refresh token
export const getRefreshToken = () => {
  return Cookies.get('refresh_token')
}

// 获取access token
export const getAccessToken = () => {
  return Cookies.get('access_token')
}